import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { htmlToText } from "html-to-text";
import { handleApiRequest } from "../../services/handleApiRequest";
import { getContentPage } from "../../redux/common/thunk";
import ContentPageSkeleton from "../../Component/skeleton/contentPageSkeleton";
import MyHelmet from "../../seo/helmet";

export default function ContentPage({ initialData }) {
  const { pathname } = useLocation();
  const slug = pathname.split("/").filter(Boolean).pop();

  const [pageData, setPageData] = useState(
    initialData.cmsPageData?.slug === slug ? initialData.cmsPageData : {}
  );

  const handlePageDetails = async () => {
    const response = await handleApiRequest(getContentPage, { pageSlug: slug });
    if (response.status) {
      setPageData(response.data);
    }
  };

  useEffect(() => {
    if (!initialData.cmsPageData || !pathname.includes(initialData.cmsPageData?.slug)) {
      handlePageDetails();
    }

    return () => {
      setPageData({});
    };
  }, [pathname, initialData]);

  return (
    <>
      {pageData?.title && (
        <MyHelmet
          title={pageData?.title}
          keywords={[]}
          description={htmlToText(pageData.content)?.slice(0, 150)}
          link={`/${pageData.slug}`}
        />
      )}

      <section className="home">
        {pageData?.title ? (
          <div className="mx-2 mx-lg-5 my-4">
            <div className="w-fit border-bottom border-danger mb-4">
              <h1 className="bg-primary border-0 text-white rounded px-3 py-1 mb-3 mt-5 h6 py-2">
                {pageData.title}
              </h1>
              <p className="border-top border-danger w-50 mb-1" />
            </div>

            <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
          </div>
        ) : (
          <ContentPageSkeleton />
        )}
      </section>
    </>
  );
}
